import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import CmsCouponsListHeaderImpl from './cms-coupons-list-header';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Header for a CMS coupons list section.
 *
 * @class CmsCouponsListHeader
 * @memberof Mojito.Modules.CmsCouponsList
 */

/**
 * CmsCouponsListHeader prop types.
 *
 * @property {string} sportId - Sport id.
 * @property {string} couponName - Coupon display name.
 * @property {boolean} isPriceBoostedCoupon - Whether the coupon is a price boosted coupon.
 * @property {boolean} isPreBuiltBetBuilderCoupon - Whether the coupon is a pre-built bet builder coupon.
 *
 * @memberof Mojito.Modules.CmsCouponsList.CmsCouponsListHeader
 */
const propTypes = {
    sportId: PropTypes.string,
    couponName: PropTypes.string,
    isPriceBoostedCoupon: PropTypes.bool,
    isPreBuiltBetBuilderCoupon: PropTypes.bool,
};

export default UIView('CmsCouponsListHeader', CmsCouponsListHeaderImpl, propTypes);
